module.exports = __webpack_public_path__ + "images/category_lp/watch/rolex/assessment_achievements/1_a21b2b9444e3f990d783c34a473e2372.png";